import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  flex: 0 0 auto;
  height: auto;
  min-height: min-content;
  max-height: none;
  overflow-x: auto;
  overflow-y: visible;
  margin: 0;
  border-radius: 20px;
  background: var(--surface-glass);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid var(--border-default);
  box-shadow: var(--shadow-md);
  padding: 0.5rem;
  transition: all 0.3s ease;
  box-sizing: border-box;

  /* Custom scrollbar vertical */
  &::-webkit-scrollbar {
    width: 10px;
  }
  
  &::-webkit-scrollbar-track {
    background: var(--scrollbar-track);
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: var(--accent);
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: var(--accent-hover);
  }

  @media screen and (max-width: 768px) {
    border-radius: 16px;
    padding: 0.3rem;
  }

  @media screen and (max-width: 480px) {
    border-radius: 12px;
  }

  @media screen and (min-width: 1920px) {
    padding: 1rem;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  height: auto;
  display: table;
  
  & > tbody {
    display: table-row-group;
    height: auto;
  }

  & > thead {
    display: table-header-group;
    height: auto;
  }

  @media screen and (max-width: 768px) {
    font-size: 13px;
  }

  @media screen and (max-width: 480px) {
    font-size: 12px;
  }
`;

export const StyledTableHead = styled.thead`
  border-bottom: var(--table-header-border);
  background: var(--table-header-bg);
  backdrop-filter: blur(10px);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  position: sticky;
  top: 0;
  z-index: 10;
  
  th:first-child {
    border-top-left-radius: 12px;
  }
  
  th:last-child {
    border-top-right-radius: 12px;
  }
`;

export const StyledTableRow = styled.tr`
  border-bottom: 2px solid var(--border-subtle);
  transition: background-color 0.3s;
  color: var(--text-primary);
  height: 100%;
  width: 100%;
`;

export const StyledTableCell = styled.td`
  padding: 12px 10px;
  text-align: center;
  color: var(--text-primary);
  font-size: 9pt;
  align-items: center;
`;

export const StyledTableHeader = styled.th`
  padding: 12px 10px;
  text-align: center;
  font-weight: var(--table-header-font-weight);
  color: var(--table-header-color);
  font-size: var(--table-header-font-size);
  text-transform: uppercase;
  letter-spacing: var(--table-header-letter-spacing);
`;

export const StyledViewLink = styled.span`
  color: var(--info);
  text-decoration: underline;
  cursor: pointer;
`;

export const StyledButtonVisualizar = styled.button`
  border: 1px solid ${props => props.$active ? 'var(--border-subtle)' : 'var(--border-subtle)'};
  
  background: ${props => {
    if (props.$active) {
      return 'var(--surface-1)';
    }
    return 'var(--brand-lime)';
  }};
  
  color: ${props => {
    if (props.$active) {
      return 'var(--text-secondary)';
    }
    return 'var(--text-on-lime)';
  }};
  
  border-radius: 20px;
  font-size: 12px;
  font-weight: ${props => props.$active ? '600' : '500'};
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: ${props => props.$active ? 'none' : 'blur(4px)'};
  box-shadow: var(--shadow-sm);
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 6px 10px;
  text-align: center;
  text-decoration: none;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 5vw;
  height: 4vh;
  z-index: 1;
  white-space: nowrap;

  &:hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.05);
  }

  @media screen and (max-width: 768px) {
    font-size: 12px;
    width: 130px;
    height: 30px;
  }
`;

export const HoverTR = styled.tr`
  border-bottom: 2px solid var(--border-subtle);
  transition: background-color 0.3s;
  color: var(--text-primary);
  height: 100%;
  width: 100%;
  
  &:hover {
    background-color: var(--table-row-hover);
  }
`;

export const DesktopOnly = styled.div`
  width: 100%;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const MobileCards = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
  }
`;

export const MobileCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0.9rem 1rem;
  border-radius: 14px;
  border: 1px solid var(--border-default);
  background: var(--surface-2);
`;

export const MobileCardTitle = styled.h3`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-heading);
`;

export const MobileCardMeta = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: var(--text-secondary);
  line-height: 1.4;
  word-break: break-word;
`;

export const MobileCardActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.35rem;

  button {
    flex: 1 1 auto;
    min-width: 120px;
  }
`;

export const ActionsCell = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;

  button {
    width: auto;
    min-width: 88px;
    height: auto;
    min-height: 36px;
    margin-right: 0;
    padding: 6px 12px;
  }
`;
